export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type: 'Container',
              name: "Container FAQ",
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'columnsFaq4',
                },
      
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};